import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ParticlesModule } from 'angular-particle';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { LateralbarComponent } from './lateralbar/lateralbar.component';
import { SecondPageComponent } from './second-page/second-page.component';
import { AllComponent } from './all/all.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ThirdPageComponent } from './third-page/third-page.component';
import { SfondoComponent } from './sfondo/sfondo.component';
import { FourthPageComponent } from './fourth-page/fourth-page.component';
import { VisionbooksPageComponent } from './visionbooks-page/visionbooks-page.component';
import { FacestarPageComponent } from './facestar-page/facestar-page.component';
import { LoveStickyPageComponent } from './love-sticky-page/love-sticky-page.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AboutUsPageComponent } from './about-us-page/about-us-page.component';
import { PressPageComponent } from './press-page/press-page.component';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ArComponent } from './ar/ar.component';
import { EmailService } from './email-service';
import { HttpModule } from '@angular/http';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    LateralbarComponent,
    SecondPageComponent,
    AllComponent,
    FooterComponent,
    ThirdPageComponent,
    SfondoComponent,
    FourthPageComponent,
    VisionbooksPageComponent,
    FacestarPageComponent,
    LoveStickyPageComponent,
    AboutUsPageComponent,
    PressPageComponent,
    ContactPageComponent,
    ArComponent
  ],
  imports: [
    BrowserModule,
    ParticlesModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule
  ],
  providers: [EmailService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts